import React, { useEffect, useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { errorResponseMessage, followerApiStatus } from "../shared/const.prop";
import Loader from "../components/Loader";
import {
  getFollowerSuggestion,
  getFollowersList,
} from "../store/actions/userActions";
import UserListView from "../components/UserListView";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import axiosHttp from "../config/axios.interceptor";

const FollowerSuggestion = () => {
  const { followerSuggestion } = useSelector((state) => state.user);
  const [suggestedFollowers, setSuggestedFollowers] = useState([]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const authContext = useContext(AuthContext);
  const appContext = useContext(AppContext);

  useEffect(() => {
    dispatch(getActiveNotificationCount());
    dispatch(getActiveChatNotificationCount());
  }, []);

  useEffect(() => {
    if (followerSuggestion) {
      setLoading(true);
      const arrayOfObjects = [];
      for (const key in followerSuggestion) {
        if (followerSuggestion.hasOwnProperty(key)) {
          arrayOfObjects.push(followerSuggestion[key]);
        }
      }
      setSuggestedFollowers(arrayOfObjects);
      setLoading(false);
    }
  }, [followerSuggestion]);

  const handleRequest = async (userId, status) => {
    try {
      const followApi = await axiosHttp.post("follow", {
        userId,
        status,
      });
      if (followApi.status === 201) {
        [followerApiStatus.accept, followerApiStatus.cancel].includes(status)
          ? dispatch(getFollowersList())
          : dispatch(getFollowerSuggestion());
        dispatch(getActiveNotificationCount());
      } else {
        appContext.updateNotificationState({
          show: true,
          type: "error",
          message: "Error, please try after sometime.",
        });
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="card card-one-1 mb-2">
      <div className="card-body">
        <p className="sug-font">Suggested for you</p>
        {suggestedFollowers.map((item, index) => (
          <UserListView key={index} user={item}>
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-outline-primary follow-btn"
                onClick={() =>
                  handleRequest(item.userId, followerApiStatus.request)
                }
              >
                Follow
              </button>
              {/* <span className="ml-3 cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6.75806 17.2428L12.0011 11.9998L17.2441 17.2428M17.2441 6.75684L12.0001 11.9998L6.75806 6.75684"
                      stroke="black"
                      strokeOpacity="0.5"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span> */}
            </div>
          </UserListView>
        ))}
      </div>
    </div>
  );
};

export default FollowerSuggestion;
